import { combineReducers } from 'redux';
import { ADD_ERROR, MARK_READED_ERROR, ADD_AUTH_ERROR } from './actionType';

const addError = (state, error) => {
  const id = state.length + 1;
  const newState = state.slice();
  if (typeof error === 'string') {
    newState.push({
      id,
      msg: error,
      readed: false,
    });
  } else {
    newState.push({
      id,
      msg: error.error,
      readed: false,
      forceLogout: error.force_logout
    });
  }

  return newState;
};
const markReadedError = (state, errorId) => state.map((item) => {
  if (item.id === errorId) {
    return Object.assign({}, item, { readed: true });
  }
  return item;
});

const AUTH_ERROR_ID = 'AUTH_ERROR_ID';
const addAuthError = (state, errorMessage) => {
  const newState = state.slice();
  newState.push({
    id: AUTH_ERROR_ID,
    msg: errorMessage,
    readed: false,
  });

  return newState;
};

const errors = (state = [], action) => {
  switch (action.type) {
    case ADD_ERROR:
      return addError(state, action.error);
    case MARK_READED_ERROR:
      return markReadedError(state, action.id);
    case ADD_AUTH_ERROR:
      return addAuthError(state, action.error);
    default:
      return state;
  }
};

export default combineReducers({ errors });



// WEBPACK FOOTER //
// ./src/store/error/reducer.js